export type StoreIconProps = {
  size?: number;
  class?: string;
};

export const AppleIcon = ({ size = 20, class: className = "" }: StoreIconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" class={className}>
    <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
  </svg>
);

export const PlayStoreIcon = ({ size = 20, class: className = "" }: StoreIconProps) => (
  <svg width={size} height={size} viewBox="0 0 512 512" class={className}>
    <path d="M48 59.49v393a17.45 17.45 0 0 0 26.27 15.1L281 256 74.26 44.38A17.46 17.46 0 0 0 48 59.49z" fill="#2196F3" />
    <path d="M281 256l78.68-78.68L126.58 38.45c-5.49-3.07-11.28-4.5-16.72-4.45L281 256z" fill="#4CAF50" />
    <path d="M281 256L109.86 478c5.44.05 11.23-1.38 16.72-4.45l233.1-138.87L281 256z" fill="#F44336" />
    <path d="M456.07 232.35L359.68 177.32 281 256l78.68 78.68 96.39-55a17.46 17.46 0 0 0 0-30.27l0-17.06z" fill="#FFC107" />
  </svg>
);
